// 2026-09-08：后台维护放行仅保存在内存，绑定真实操作员会话、机构、运行域和维护批次，不授予业务权限。
type Context = { token: string; operatorId: number; orgId: number }
type MaintenanceConfig = { enabled: boolean; updatedAt?: string }
export function createOperatorMaintenanceTester(getContext: () => Context, fetchAccess: () => Promise<any>, now: () => number = Date.now) {
  let serial = 0
  let attempting = false
  let grant: { context: Context; revision: string; runtimeId: string; expiresAt: number } | null = null
  const same = (a: Context, b: Context) => a.token === b.token && a.operatorId === b.operatorId && a.orgId === b.orgId
  const clear = () => { serial++; attempting = false; grant = null }
  const active = (config: MaintenanceConfig) => Boolean(config.enabled && grant && config.updatedAt
    && grant.revision === config.updatedAt && grant.expiresAt > now() && same(grant.context, getContext()))
  return {
    begin() { clear(); attempting = true }, clear, active,
    attempting: () => attempting,
    expiresAt: () => grant?.expiresAt || 0,
    async verify(config: MaintenanceConfig) {
      if (!config.enabled) { clear(); return false }
      if (!attempting) return false
      const context = getContext(), previous = grant, requestSerial = ++serial
      if (!context.token || context.operatorId <= 0 || context.orgId <= 0) { grant = null; return false }
      if (previous && (previous.revision !== config.updatedAt || !same(previous.context, context))) { clear(); return false }
      try {
        const response = await fetchAccess()
        if (requestSerial !== serial || !same(context, getContext())) return false
        if (response?.allowed !== true || response.operatorId !== context.operatorId || response.orgId !== context.orgId
          || !config.updatedAt || response.maintenanceRevision !== config.updatedAt
          || typeof response.runtimeId !== 'string' || !response.runtimeId
          || previous && previous.runtimeId !== response.runtimeId || !Number.isFinite(response.expiresAt) || response.expiresAt <= now()) {
          grant = null; return false
        }
        grant = { context, revision: config.updatedAt, runtimeId: response.runtimeId, expiresAt: Math.min(response.expiresAt, now() + 30000) }
        return true
      } catch (_error) { if (requestSerial === serial) grant = null; return false }
    }
  }
}
